import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Modal,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Tooltip,
} from '@mui/material'
import { useStyles } from '../CaseDiagnosisStyles'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearSessionToken,
  getSignedUrlToGetReport,
  getSignedUrlToGetTrf,
  getURLForReportPDF,
  saveReportData,
  setPDFBytes,
  tokenActive,
  amendReportUpload,
} from '../../../actions'
import { RootState } from '../../../reducers'
import { tableCellClasses } from '@mui/material/TableCell'
import { styled } from '@mui/material/styles'
import { format, parseISO } from 'date-fns'
import PreviewIcon from '@mui/icons-material/Preview'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import ReleaseAmendmentReport from '../../HOC/ReleaseAmendmentReport'
import ReleasePrimaryReport from '../../HOC/ReleasePrimaryReport'
import ReleaseConfirmation from '../../HOC/ReleaseConfirmation'
import ReleaseAuthPrompt from '../../HOC/ReleaseAuthPrompt'
import ReleaseValidation from '../../HOC/ReleaseValidation'
import ReceiptIcon from '@mui/icons-material/Receipt'
import FeedIcon from '@mui/icons-material/Feed'
import PreviewReport from '../ReportGenerator/PreviewReport'
import ConsultCase from './ConsultCase'
import ConsultComplete from './ConsultComplete'
import CancelConsult from './CancelConsult'
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined'
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { Clear as ClearIcon } from '@mui/icons-material'

export default function ReportInformation({
  caseView,
  trfBarcode,
  isAmendFlow,
  isReadOnlyMode,
  handleReleaseReport,
  handleConsultCase,
  handleConsultComplete,
}) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { user } = useSelector((state: RootState) => state.userLogin)
  const getReportHistory = useSelector((state: RootState) => state.getReportHistoryData)
  const [pdfUrl, setPdfUrl] = useState('')
  const [isTokenAcquired, setTokenAcquired] = useState(false)
  const [open, setOpen] = useState(false)
  const [slideDiagnosisValidation, setSlideDiagnosisValidation] = useState(true)
  const [consultValidation, setConsultValidation] = useState(true)
  const [caseDiagnosisValidation, setCaseDiagnosisValidation] = useState(true)
  const [recutValidation, setRecutValidation] = useState(true)
  const [isPreviewOpen, setPreviewOpen] = useState(false)
  const [isConsultOpen, setConsultOpen] = useState(false)
  const [isConsultCompleteOpen, setConsultCompleteOpen] = useState(false)
  const [isConsultComplete, setConsultComplete] = useState(false)
  const [isTrfOpen, setTrfOpen] = useState(false)
  const [isCurrentReportOpen, setCurrentReportOpen] = useState(false)
  const [isRecutValidationError, setRecutValidationError] = useState(false)
  const [trfPdfUrl, setTrfPdfUrl] = useState('')
  const [currentReportUrl, setCurrentReportUrl] = useState('')
  const [savedConsults, setSavedConsults] = useState([] as any)
  const [isReleaseAmendmentReportOpen, setReleaseAmendmentReportOpen] = useState(false)
  const [isReleasePrimaryReportOpen, setReleasePrimaryReportOpen] = useState(false)
  const [isReleaseConfirmationOpen, setReleaseConfirmationOpen] = useState(false)
  const [isReleaseAuthPromptOpen, setReleaseAuthPromptOpen] = useState(false)
  const [isReleaseValidationOpen, setReleaseValidationOpen] = useState(false)
  const [cancelled, setCancelledArray] = useState([] as any)
  const [isCancelled, setCancelled] = useState(false)
  const {
    workflowId,
    caseNumber,
    pathologistId,
    mcFlag,
    nlOrderId,
    slideStatusId,
    statFlag,
    userCaseWorkflowId,
    caseId,
  } = useSelector((state: RootState) => state.getCaseData)
  const { re_saveReportData_success, re_saveReportData_error } = useSelector(
    (state: RootState) => state.saveReportDataResponse,
  )
  const [isReportClicked, setReportClicked] = useState(false)
  const { isTokenActive } = useSelector((state: RootState) => state.tokenActiveStatus)
  const url = useSelector((state: RootState) => state.setSignedUrlToGetReport)
  const trfUrl = useSelector((state: RootState) => state.setSignedUrlToGetTrf)
  const draftData = useSelector((state: RootState) => state.setDraftReportData)
  const reportData = useSelector((state: RootState) => state.setReportData)
  const slideDiagnosisData = useSelector((state: RootState) => state.getSlideDiagnosisData)
  const [isReleaseSuccess, setReleaseSuccess] = useState(false)
  const getReportClassname = () =>
    getReportHistory &&
    getReportHistory.payload &&
    getReportHistory.payload.currentReport &&
    getReportHistory.payload.currentReport.url !== null
      ? `${classes.btn}`
      : `${classes.disableBtn}`
  const [isCancelConsultOpen, setCancelConsultOpen] = useState(false)
  const getPreviewButtonClassName = () =>
    workflowId == 'PRIMARY_DIAGNOSIS_RESULTED_RESULT_RELEASED' ||
    workflowId == 'CORRECT_RESULTED_RESULT_RELEASED' ||
    workflowId == 'AMEND_RESULTED_RESULT_RELEASED'
      ? `${classes.disableBtn} `
      : `${classes.previewReportButton}`
  const getButtonClassName = () =>
    (isReadOnlyMode && isAmendFlow === false) || isCancelled
      ? `${classes.disableBtn} ${classes.releaseBtn}`
      : workflowId === 'AMEND_INITIATED' || workflowId === 'AMEND_RESULTED_RESULT_RELEASED'
      ? `${classes.btn} ${classes.amendBtn}`
      : `${classes.btn} ${classes.releaseBtn}`
  const getConsultButtonClassName = () =>
    isReadOnlyMode &&
    workflowId !== 'PRIMARY_DIAGNOSIS_ASSIGNED_CONSULT' &&
    workflowId !== 'CORRECT_ASSIGNED_CONSULT' &&
    workflowId !== 'AMEND_INITIATED' &&
    workflowId !== 'AMEND_RESULTED_RESULT_RELEASED'
      ? `${classes.disableBtn} `
      : `${classes.previewReportButton}`

  useEffect(() => {
    if (reportData.sampleInfo) {
      handleCancellation()
    }
  }, [trfBarcode])

  useEffect(() => {
    dispatch(getURLForReportPDF({ trfBarcode: trfBarcode }))
  }, [trfBarcode])

  const handleCancellation = () => {
    if (reportData && reportData.sampleInfo && reportData.sampleInfo.sampleInfoTree) {
      let cancellationStatus = isCancelled
      for (let i = 0; i < reportData.sampleInfo.sampleInfoTree.length; i++) {
        const validChildren = [] as any
        const parentObject = reportData.sampleInfo.sampleInfoTree[i]
        const cancelledArray = cancelled
        if (parentObject && parentObject.children && parentObject.children.length) {
          parentObject.children.map((child) => {
            if (!child.inactiveReason) {
              validChildren.push(child)
            }
          })
          if (validChildren.length === 0) {
            cancelledArray.push(true)
            setCancelledArray(cancelledArray)
            cancellationStatus = cancellationStatus && true
          } else {
            cancellationStatus = cancellationStatus && false
            cancelledArray.push(false)
            setCancelledArray(cancelledArray)
          }
        }
      }
      setCancelled(cancellationStatus)
    }
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#9bbbcc',
      //color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }))

  const handleReportSelect = async (listItem) => {
    await dispatch(getSignedUrlToGetReport({ url: listItem.url }))
    setOpen(true)
  }

  useEffect(() => {
    if (open && url.payload) {
      setPdfUrl(url.payload)
    }
  }, [open, url])

  useEffect(() => {
    if (isTrfOpen) {
      setTrfPdfUrl(trfUrl.payload)
    }
  }, [isTrfOpen, trfUrl])

  useEffect(() => {
    if (isCurrentReportOpen) {
      setCurrentReportUrl(url.payload)
    }
  }, [isCurrentReportOpen, url])

  const handleClose = async () => {
    setOpen(false)
    setPdfUrl('')
    await dispatch(setPDFBytes({ pdfUrl: '' }))
    setPreviewOpen(false)
  }

  useEffect(() => {
    if (re_saveReportData_success) {
      if (workflowId === 'AMEND_INITIATED' || workflowId === 'AMEND_RESULTED_RESULT_RELEASED') {
        dispatch(
          amendReportUpload({
            caseNumber: caseNumber,
            pathologistId: pathologistId,
            caseId: caseId,
            nlOrderId: nlOrderId,
            userCaseWorkflowId: userCaseWorkflowId,
            slideStatusId: slideStatusId,
            mcFlag: mcFlag,
            statFlag: statFlag,
            userId: user,
          }),
        )
        setReleaseAmendmentReportOpen(false)
        setReleaseConfirmationOpen(true)
      } else {
        setReleasePrimaryReportOpen(false)
        setReleaseConfirmationOpen(true)
      }
    }
  }, [re_saveReportData_success, workflowId])

  const handleTrfClose = () => {
    setTrfOpen(false)
  }

  const handleCurrentReportClose = () => {
    setCurrentReportOpen(false)
  }

  const validateDiagnosis = async () => {
    await dispatch(tokenActive({ userId: user }))
    setTokenAcquired(true)
    setReportClicked(true)
    setPdfUrl('')
    const recutValidationSuccess = validateRecutsData()
    await dispatch(setPDFBytes({ pdfUrl: '' }))
    let caseDiagnosisSuccess = true
    let consultSuccess = true
    let slideDiagnosisSuccess = true
    if (reportData && reportData.sampleInfo && reportData.sampleInfo.sampleInfoTree) {
      reportData.sampleInfo.sampleInfoTree.forEach(async function (object, index) {
        const locationName = object.location
        let cancelledCount = 0
        object.children.forEach(function (item, index) {
          if (item.inactiveReason?.toLowerCase() === 'cancelled') {
            cancelledCount++
          }
        })
        if (cancelledCount !== object.children.length) {
          if (draftData && draftData.reportBuilder && draftData.reportBuilder[locationName]) {
            const locationObject = draftData.reportBuilder[locationName]
            if (locationObject['Case Diagnosis'] && locationObject['Case Diagnosis'].length) {
              caseDiagnosisSuccess = caseDiagnosisSuccess && true
            } else {
              caseDiagnosisSuccess = caseDiagnosisSuccess && false
            }
          } else {
            caseDiagnosisSuccess = false
          }
        } else {
          caseDiagnosisSuccess = caseDiagnosisSuccess && true
        }
      })
    }
    if (draftData.calloutDecision) {
      if (draftData.consultedPats && draftData.consultedPats.length > 0) {
        consultSuccess = true
      } else {
        consultSuccess = false
      }
    } else {
      consultSuccess = true
    }
    if (slideDiagnosisData && slideDiagnosisData.payload) {
      const diagnosis = slideDiagnosisData.payload
      for (let x = 0; x < diagnosis.length; x++) {
        const currentStainDiagnosis = diagnosis[x]
        if (!currentStainDiagnosis.inactiveReason && currentStainDiagnosis.isDiagnosed === null) {
          slideDiagnosisSuccess = false
          break
        }
      }
    }
    if (recutValidationSuccess) {
      setRecutValidation(true)
    } else {
      setRecutValidation(false)
    }
    setSlideDiagnosisValidation(slideDiagnosisSuccess)
    setConsultValidation(consultSuccess)
    setCaseDiagnosisValidation(caseDiagnosisSuccess)
    const isSuccess = caseDiagnosisSuccess && consultSuccess && slideDiagnosisSuccess && recutValidationSuccess
    setReleaseSuccess(isSuccess)
    if (!isSuccess) {
      setReleaseValidationOpen(true)
    }
  }

  useEffect(() => {
    if (isReleaseSuccess && isTokenAcquired && isReportClicked) {
      dispatch(getURLForReportPDF({ trfBarcode: trfBarcode }))
      setReleaseAuthPromptOpen(!isTokenActive)
      setReleasePrimaryReportOpen(isTokenActive)
      setReportClicked(false)
    }
  }, [isTokenAcquired, isReleaseSuccess, isReportClicked, isReleaseSuccess])

  const validateRecutsData = () => {
    const slideDataObject = {} as any
    let isSuccess = true
    if (reportData && reportData.sampleInfo && reportData.sampleInfo.sampleInfoTree) {
      for (let i = 0; i < reportData.sampleInfo.sampleInfoTree.length; i++) {
        slideDataObject.slideData = reportData.sampleInfo.sampleInfoTree[i]
        if (slideDataObject.slideData) {
          slideDataObject.slideData.children.forEach((parentObject) => {
            const stainNamesData = [] as any
            if (
              parentObject &&
              parentObject.children &&
              parentObject.children.length &&
              parentObject.children[0] &&
              parentObject.children[0].children &&
              parentObject.children[0].children.length
            ) {
              parentObject.children[0].children.forEach((object) => {
                if (!object.inactiveReason) stainNamesData.push(object.sampleStain)
              })
            }
            if (parentObject.children && parentObject.children.length) {
              parentObject.children.forEach((object) => {
                if (!object.inactiveReason) stainNamesData.push(object.sampleStain)
              })
            }
            const duplicateStains = stainNamesData.filter(
              (item, index) => item !== undefined && stainNamesData.indexOf(item) !== index,
            )
            if (duplicateStains.length > 0) {
              isSuccess = false
            }
          })
        }
      }
    }
    return isSuccess
  }

  const handlePreviewReportOpen = async () => {
    if (workflowId !== 'AMEND_INITIATED' && workflowId !== 'AMEND_RESULTED_RESULT_RELEASED') {
      const recutValidationSuccess = validateRecutsData()
      if (recutValidationSuccess) {
        setPreviewOpen(true)
        setPdfUrl('')
        await dispatch(setPDFBytes({ pdfUrl: '' }))
        setRecutValidationError(false)
      } else {
        setRecutValidationError(true)
      }
    } else {
      setPreviewOpen(true)
      setPdfUrl('')
      await dispatch(setPDFBytes({ pdfUrl: '' }))
      setRecutValidationError(false)
    }
  }

  const handleConsultOpen = () => {
    setConsultOpen(true)
  }

  const handleConsultClose = () => {
    setConsultOpen(false)
  }

  const handleConsultSuccess = () => {
    setConsultOpen(false)
    handleConsultCase()
    setConsultComplete(true)
  }

  const handleCancelConsultSuccess = () => {
    setCancelConsultOpen(false)
    setConsultComplete(false)
    handleConsultComplete()
  }

  const handleConsultCompleteSuccess = () => {
    setConsultCompleteOpen(false)
    setConsultComplete(false)
    handleConsultComplete()
  }

  const handleConsultCompleteOpen = () => {
    setConsultCompleteOpen(true)
  }

  const handleConsultCompleteClose = () => {
    setConsultCompleteOpen(false)
  }

  const handleCancelConsultOpen = () => {
    setCancelConsultOpen(true)
  }

  const handleCancelConsultClose = () => {
    setCancelConsultOpen(false)
  }

  const handleCurrentReportOpen = async () => {
    await dispatch(getSignedUrlToGetReport({ url: getReportHistory.payload.currentReport.url }))
    setCurrentReportOpen(true)
  }

  const handleTrfOpen = async () => {
    await dispatch(getSignedUrlToGetTrf({ url: getReportHistory.payload.trf.url }))
    setTrfOpen(true)
  }

  const handleRecutsErrorClose = () => {
    setRecutValidationError(false)
  }

  const getStatus = () => {
    if (isCancelled) {
      return 'All the locations are cancelled for this case'
    }
    switch (workflowId) {
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_CONSULT':
        return 'This case is being consulted with other pathologist.'
      case 'CORRECT_ASSIGNED_READY':
        return 'This case is submitted for report correction.'
      case 'CORRECT_ASSIGNED_INPROGRESS':
        return 'This case is submitted for report correction.'
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS':
        return 'Diagnosis is in progress for this case.'
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_READY':
        return 'Diagnosis is in progress for this case.'
      case 'PRIMARY_DIAGNOSIS_RESULTED_2HRWINDOW':
        return 'Diagnosis resulted, the report is in 2 hr window for submission.'
      case 'CORRECT_RESULTED_2HRWINDOW':
        return 'Report correction is completed and the report is in 2 hr window for submission.'
      case 'AMEND_RESULTED_2HRWINDOW':
        return 'Report amendment is completed and it is in 2 hr window for submission.'
      case 'AMEND_INITIATED':
        return 'This case is initiated for report amendment.'
      case 'PRIMARY_DIAGNOSIS_RESULTED_RESULT_RELEASED':
        return 'Diagnosis resulted and the report is released.'
      case 'CORRECT_RESULTED_RESULT_RELEASED':
        return 'Correction resulted and the report is released.'
      case 'AMEND_RESULTED_RESULT_RELEASED':
        return 'Amended report is released.'
    }
  }

  const handleReleaseAmendmentReportClose = () => {
    setReleaseAmendmentReportOpen(false)
    setReleaseConfirmationOpen(false)
  }

  const handleReleaseAuthPromptClose = async (flag) => {
    setReleaseAuthPromptOpen(false)
    setReleaseConfirmationOpen(false)
    if (flag) {
      setReleasePrimaryReportOpen(true)
      await dispatch(tokenActive({ userId: user }))
      setTokenAcquired(true)
    }
    dispatch(clearSessionToken())
  }

  const handleReleaseConfirmationClose = () => {
    dispatch(
      amendReportUpload({
        pathologistId: '',
        caseNumber: '',
        caseId: '',
        nlOrderId: '',
        userCaseWorkflowId: '',
        slideStatusId: '',
        mcFlag: '',
        statFlag: '',
        userId: '',
      }),
    )
    setReleaseConfirmationOpen(false)
    setReleaseAuthPromptOpen(false)
    setReleasePrimaryReportOpen(false)
    setReleaseValidationOpen(false)
    setReleaseSuccess(false)
    handleReleaseReport()
  }

  const handleReleasePrimaryReportClose = () => {
    setReleasePrimaryReportOpen(false)
    setReleaseConfirmationOpen(false)
  }

  const handleReleaseValidationClose = () => {
    setReleaseValidationOpen(false)
  }

  const handleReleaseAmendmentReport = () => {
    setReleaseAmendmentReportOpen(true)
  }

  return (
    <>
      <Box className={classes.reportInformation}>
        <div className={classes.reportSectionTitle}>Reports</div>
        <div className={classes.reportTitle} style={{ marginBottom: '10px' }}>
          <h3 style={{ width: '180px', margin: '5px 0px 10px 0px' }}>
            <label style={{ width: '140px' }}>Report Actions</label>
          </h3>
          <label className={isCancelled ? classes.cancelledStatusMessage : classes.statusMessageCorrect}>
            {getStatus()}
          </label>
          <br />
          {savedConsults && savedConsults.length > 0 && (
            <label className={classes.statusMessageConsult}>This case is consulted by {savedConsults.toString()}</label>
          )}
        </div>
        <div>
          <Tooltip title="Generate and preview the report for the case" placement="top-start">
            <Button
              className={getPreviewButtonClassName()}
              onClick={handlePreviewReportOpen}
              style={{ marginLeft: '20px', width: '150px' }}
              variant="outlined"
              startIcon={<PreviewIcon />}
            >
              Preview
            </Button>
          </Tooltip>
          {isAmendFlow ? (
            <Tooltip title="Release the diagnosis report" placement="top-start">
              <Button
                className={getButtonClassName()}
                variant="outlined"
                onClick={handleReleaseAmendmentReport}
                style={{ marginLeft: '20px' }}
                startIcon={<CloudUploadIcon />}
              >
                Release Amended Report
              </Button>
            </Tooltip>
          ) : (
            <Tooltip title="Release the diagnosis report" placement="top-start">
              <Button
                className={getButtonClassName()}
                variant="outlined"
                onClick={validateDiagnosis}
                style={{ marginLeft: '20px' }}
                startIcon={<CloudUploadIcon />}
              >
                Release
              </Button>
            </Tooltip>
          )}
        </div>
        <div className={classes.mt}>
          {isConsultComplete === false &&
            (workflowId === 'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS' ||
              workflowId === 'PRIMARY_DIAGNOSIS_ASSIGNED_READY' ||
              workflowId === 'PRIMARY_DIAGNOSIS_RESULTED_2HRWINDOW' ||
              workflowId === 'CORRECT_ASSIGNED_READY' ||
              workflowId === 'CORRECT_ASSIGNED_INPROGRESS' ||
              workflowId === 'CORRECT_RESULTED_2HRWINDOW') && (
              <Tooltip title="Begin the consultation" placement="top-start">
                <Button
                  className={getConsultButtonClassName()}
                  variant="outlined"
                  style={{ marginLeft: '20px', width: '150px' }}
                  onClick={handleConsultOpen}
                  startIcon={<AssignmentOutlinedIcon />}
                >
                  Consult
                </Button>
              </Tooltip>
            )}
          {(isConsultComplete ||
            workflowId === 'PRIMARY_DIAGNOSIS_ASSIGNED_CONSULT' ||
            workflowId === 'CORRECT_ASSIGNED_CONSULT') && (
            <>
              <Tooltip title="Consultation completed, ready to resume diagnosis" placement="top-start">
                <Button
                  className={classes.btn}
                  variant="outlined"
                  onClick={handleConsultCompleteOpen}
                  startIcon={<AssignmentTurnedInOutlinedIcon />}
                >
                  Consult Complete
                </Button>
              </Tooltip>
              <Tooltip title="Cancel Consultation" placement="top-start">
                <Button
                  className={classes.previewReportButton}
                  variant="outlined"
                  onClick={handleCancelConsultOpen}
                  startIcon={<AssignmentTurnedInOutlinedIcon />}
                >
                  Cancel Consult
                </Button>
              </Tooltip>
            </>
          )}
        </div>
        <Divider className={classes.divider} />
        <div className={classes.reportTitle}>
          <h3>Reports</h3>
        </div>
        {getReportHistory && getReportHistory.payload && getReportHistory.payload.trf && (
          <div style={{ float: 'left' }}>
            <Tooltip title="View TRF" placement="top-start">
              <Button
                className={classes.previewReportButton}
                variant="outlined"
                onClick={handleTrfOpen}
                style={{ width: '160px' }}
                startIcon={<ReceiptIcon />}
              >
                TRF
              </Button>
            </Tooltip>
          </div>
        )}
        {getReportHistory && getReportHistory.payload && getReportHistory.payload.currentReport && (
          <div className={classes.mt}>
            <Tooltip title="View Current Report" placement="top-start">
              <Button
                className={getReportClassname()}
                variant="outlined"
                style={{ width: '150px' }}
                onClick={handleCurrentReportOpen}
                startIcon={<FeedIcon />}
              >
                Report
              </Button>
            </Tooltip>
          </div>
        )}
        <ConsultCase open={isConsultOpen} onClose={handleConsultClose} handleConsult={handleConsultSuccess} />
        <CancelConsult
          open={isCancelConsultOpen}
          onClose={handleCancelConsultClose}
          handleCancelConsult={handleCancelConsultSuccess}
        />
        <ConsultComplete
          open={isConsultCompleteOpen}
          onClose={handleConsultCompleteClose}
          handleConsultCompleteSuccess={handleConsultCompleteSuccess}
          savedConsults={savedConsults}
          setSavedConsults={setSavedConsults}
        />
        <ReleaseAmendmentReport
          isReleaseAmendmentReportOpen={isReleaseAmendmentReportOpen}
          handleReleaseAmendmentReportClose={handleReleaseAmendmentReportClose}
          trfBarcode={trfBarcode}
          pdfUrl={pdfUrl}
          setPdfUrl={setPdfUrl}
        />
        {isReleasePrimaryReportOpen && isTokenActive && isTokenAcquired && (
          <ReleasePrimaryReport
            isReleasePrimaryReportOpen={isReleasePrimaryReportOpen}
            handleReleasePrimaryReportClose={handleReleasePrimaryReportClose}
            trfBarcode={trfBarcode}
            pdfUrl={pdfUrl}
            setPdfUrl={setPdfUrl}
          />
        )}
        {isReleaseConfirmationOpen && (
          <ReleaseConfirmation
            isReleaseConfirmationOpen={isReleaseConfirmationOpen}
            handleReleaseConfirmationClose={handleReleaseConfirmationClose}
          />
        )}
        <ReleaseAuthPrompt
          isReleaseAuthPromptOpen={isReleaseAuthPromptOpen}
          handleReleaseAuthPromptClose={handleReleaseAuthPromptClose}
          isTokenActive={isTokenActive}
          setPdfUrl={setPdfUrl}
        />
        {isReleaseSuccess !== undefined && isReportClicked !== undefined && (
          <ReleaseValidation
            isReleaseValidationOpen={isReleaseValidationOpen}
            handleReleaseValidationClose={handleReleaseValidationClose}
            slideDiagnosisValidation={slideDiagnosisValidation}
            consultValidation={consultValidation}
            caseDiagnosisValidation={caseDiagnosisValidation}
            recutValidation={recutValidation}
          />
        )}
        <Modal
          open={isPreviewOpen}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box>
            <PreviewReport
              trfBarcode={trfBarcode}
              handleClose={handleClose}
              location={null}
              pdfUrl={pdfUrl}
              setPdfUrl={setPdfUrl}
            />
          </Box>
        </Modal>
        <Divider className={classes.divider} />
        <div className={classes.reportTitle}>
          <h3>Report History </h3>
        </div>

        {getReportHistory && (
          <div className={classes.reportHistory}>
            <Table stickyHeader key="reportHistory" size="small">
              <TableHead>
                <TableRow>
                  <StyledTableCell style={{ width: '8%' }}>Report Name</StyledTableCell>
                  <StyledTableCell style={{ width: '10%' }}>Receipt Date</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getReportHistory &&
                  getReportHistory.payload &&
                  getReportHistory.payload.reportHistory &&
                  getReportHistory.payload.reportHistory.length > 0 &&
                  getReportHistory.payload.reportHistory.map((listItem, index) => (
                    <TableRow key={index}>
                      <StyledTableCell>
                        <label className={classes.reportLink} onClick={() => handleReportSelect(listItem)}>
                          {listItem?.dr.replaceAll(' ', '') + '_' + listItem?.timeStamp.substring(0, 19)}
                        </label>
                      </StyledTableCell>
                      <StyledTableCell>
                        <label className={classes.reportDate}>
                          {format(parseISO(listItem.timeStamp), 'yyyy-MM-dd HH:mm:ss')}
                        </label>
                      </StyledTableCell>
                    </TableRow>
                  ))}
                {getReportHistory &&
                  getReportHistory.payload &&
                  getReportHistory.payload.reportHistory &&
                  getReportHistory.payload.reportHistory.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={2} align="center">
                        <label>No records found</label>
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            </Table>
          </div>
        )}
        <Dialog
          fullWidth
          maxWidth={'md'}
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className={classes.dialogHeight}>
            <iframe src={pdfUrl} title="testPdf" height="100%" width="100%" />
          </DialogContent>
        </Dialog>

        <Dialog
          maxWidth={'md'}
          fullWidth
          open={isTrfOpen}
          onClose={handleTrfClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className={classes.dialogHeight}>
            <iframe src={trfPdfUrl} title="testPdf" height="100%" width="100%" />
          </DialogContent>
        </Dialog>

        <Dialog
          fullWidth
          maxWidth={'md'}
          open={isCurrentReportOpen}
          onClose={handleCurrentReportClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className={classes.dialogHeight}>
            <iframe src={currentReportUrl} title="testPdf" height="100%" width="100%" />
          </DialogContent>
        </Dialog>

        <Dialog fullWidth maxWidth="sm" open={isRecutValidationError} onClose={handleRecutsErrorClose}>
          <DialogTitle className={classes.dialogTitle}>Slides validation error</DialogTitle>
          <Divider />
          <DialogContent>
            <>
              <ErrorOutlineIcon style={{ color: 'red', width: '50px', verticalAlign: 'middle' }} />
              Duplicate slides are included in the report, please check slide diagnosis inclusion and try again.
            </>
          </DialogContent>
          <DialogActions className={classes.buttonActions}>
            <Button
              className={`${classes.buttonMargin}`}
              variant="outlined"
              endIcon={<ClearIcon />}
              onClick={handleRecutsErrorClose}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  )
}
